export default __webpack_public_path__ + "images/550251d4e356bfa2525b1afaa250bede-august_banner_desktop-2.webp";